export const SPEED_DROPDOWN_Y_AXIS_CONFIG = {
  optionList: [
    {
      id: 1,
      name: 'Recovery Index',
      slug: 'recovery_index',
      datapoint: 'data_point-0',
      value: 'recovery_index__data_point-0',
      color: '#48D1CC',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [10, 50, 95, 67]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [10, 50, 95, 67]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [10, 50, 95, 67]
        },
        {
          sport_id_list: [68],
          data_set: [10, 50, 95, 67]
        },
        {
          sport_id_list: [86],
          data_set: [10, 50, 95, 67]
        },
        {
          sport_id_list: [81, 79],
          data_set: [10, 50, 95, 67]
        },
        {
          sport_id_list: [71],
          data_set: [10, 50, 95, 67]
        },
      ],
    },
    {
      id: 2,
      name: 'Accumulation Index',
      slug: 'accumulation_index',
      datapoint: 'data_point-0',
      value: 'accumulation_index__data_point-0',
      color: '#00CED1',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [95, 67, 10, 50]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [95, 67, 10, 50]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [95, 67, 10, 50]
        },
        {
          sport_id_list: [68],
          data_set: [95, 67, 10, 50]
        },
        {
          sport_id_list: [86],
          data_set: [95, 67, 10, 50]
        },
        {
          sport_id_list: [81, 79],
          data_set: [95, 67, 10, 50]
        },
        {
          sport_id_list: [71],
          data_set: [95, 67, 10, 50]
        },
      ],
    },
    {
      id: 3,
      name: 'W` - Absolute [kJ]',
      slug: 'w_prime',
      datapoint: 'data_point-1',
      value: 'w_prime__data_point-1',
      color: '#4B0014',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [700, 1500, 2400, 1700]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [700, 1500, 2400, 1700]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [700, 1500, 2400, 1700]
        },
        {
          sport_id_list: [68],
          data_set: [700, 1500, 2400, 1700]
        },
        {
          sport_id_list: [86],
          data_set: [700, 1500, 2400, 1700]
        },
        {
          sport_id_list: [81, 79],
          data_set: [700, 1500, 2400, 1700]
        },
        {
          sport_id_list: [71],
          data_set: [700, 1500, 2400, 1700]
        },
      ],
    },
    {
      id: 4,
      name: 'W` - Relative [kJ/kg]',
      slug: 'w_prime',
      datapoint: 'data_point-2',
      value: 'w_prime__data_point-2',
      color: '#8a5966',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [11, 21, 28, 23]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [11, 21, 28, 23]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [11, 21, 28, 23]
        },
        {
          sport_id_list: [68],
          data_set: [11, 21, 28, 23]
        },
        {
          sport_id_list: [86],
          data_set: [11, 21, 28, 23]
        },
        {
          sport_id_list: [81, 79],
          data_set: [11, 21, 28, 23]
        },
        {
          sport_id_list: [71],
          data_set: [11, 21, 28, 23]
        },
      ],
    },
    {
      id: 5,
      name: 'Max Lactate [mmol/l]',
      slug: 'max_lactate',
      datapoint: 'data_point-1',
      value: 'max_lactate__data_point-1',
      color: '#FF2400',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [6, 11, 25, 16]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [6, 11, 25, 16]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [6, 11, 25, 16]
        },
        {
          sport_id_list: [68],
          data_set: [6, 11, 25, 16]
        },
        {
          sport_id_list: [86],
          data_set: [6, 11, 25, 16]
        },
        {
          sport_id_list: [81, 79],
          data_set: [6, 11, 25, 16]
        },
        {
          sport_id_list: [71],
          data_set: [6, 11, 25, 16]
        },
      ],
    },
    {
      id: 6,
      name: 'Max Heart Rate - Maximum [bpm]',
      slug: 'max_hr',
      datapoint: 'data_point-1',
      value: 'max_hr__data_point-1',
      color: '#800000',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [140, 190, 220, 175]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [140, 190, 220, 175]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [140, 190, 220, 175]
        },
        {
          sport_id_list: [68],
          data_set: [140, 190, 220, 175]
        },
        {
          sport_id_list: [86],
          data_set: [140, 190, 220, 175]
        },
        {
          sport_id_list: [81, 79],
          data_set: [140, 190, 220, 175]
        },
        {
          sport_id_list: [71],
          data_set: [140, 190, 220, 175]
        },
      ],
    },
    {
      id: 7,
      name: 'Max Heart Rate - PWC150 [{0}]',
      slug: 'max_hr',
      datapoint: 'data_point-2',
      value: 'max_hr__data_point-2',
      color: '#993333',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [2.599005405, 7.772951351, 16.5635027, 8.964162162]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [0.980853179, 1.432535672, 1.759145557, 1.348130896]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [0.861022286, 3.522261655, 7.907746816, 4.182354735]
        },
        {
          sport_id_list: [68],
          data_set: [1.950640246, 3.999542305, 6.098587345, 4.087659493]
        },
        {
          sport_id_list: [86],
          data_set: [0.666411642, 2.537388773, 5.846968815, 3.031247401]
        },
        {
          sport_id_list: [81, 79],
          data_set: [1.260275411, 4.134879782, 8.779486443, 4.784225574]
        },
        {
          sport_id_list: [71],
          data_set: [1.397314734, 4.179006103, 8.90510898, 4.19442023]
        },
      ],
    },
    {
      id: 8,
      name: 'Economy [J/m]',
      datapoint: 'data_point-1',
      slug: 'economy',
      color: 'black',
    },
    {
      id: 9,
      name: 'LT1 [{0}]',
      slug: 'lt_1',
      datapoint: 'data_point-1',
      value: 'lt1__data_point-1',
      color: '#DB7093',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [2.16, 4.76, 8.76, 5.96]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [0.815174475, 0.877256205, 0.930365718, 0.896331413]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [0.71558456, 2.156962616, 4.182198859, 2.780721028]
        },
        {
          sport_id_list: [68],
          data_set: [1.621152046, 2.449239743, 3.2253821, 2.717761029]
        },
        {
          sport_id_list: [86],
          data_set: [0.553846154, 1,.553846154, 3.092307692, 2.015384615]
        },
        {
          sport_id_list: [81, 79],
          data_set: [1.047398702, 2.532117708, 4.643238971, 3.180886725]
        },
        {
          sport_id_list: [71],
          data_set: [1.161290323, 2.559139785, 4.709677419, 3.204301075]
        },
      ],
    },
    {
      id: 10,
      name: 'LT1',
      slug: 'lt_1',
      datapoint: 'data_point-2',
      value: 'lt1__data_point-2',
      color: '#8e4960',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [1, 2, 5.5, 3]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [1, 2, 5.5, 3]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [1, 2, 5.5, 3]
        },
        {
          sport_id_list: [68],
          data_set: [1, 2, 5.5, 3]
        },
        {
          sport_id_list: [86],
          data_set: [1, 2, 5.5, 3]
        },
        {
          sport_id_list: [81, 79],
          data_set: [1, 2, 5.5, 3]
        },
        {
          sport_id_list: [71],
          data_set: [1, 2, 5.5, 3]
        },
      ],
    },
    {
      id: 11,
      name: 'VO2Max - Absolute [ml/min]',
      slug: 'vo2max',
      datapoint: 'data_point-1',
      value: 'vo2max__data_point-1',
      color: 'blue',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [1800, 3700, 3000, 5800]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [1800, 3700, 3000, 5800]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [1800, 3700, 3000, 5800]
        },
        {
          sport_id_list: [68],
          data_set: [1800, 3700, 3000, 5800]
        },
        {
          sport_id_list: [86],
          data_set: [1800, 3700, 3000, 5800]
        },
        {
          sport_id_list: [81, 79],
          data_set: [1800, 3700, 3000, 5800]
        },
        {
          sport_id_list: [71],
          data_set: [1800, 3700, 3000, 5800]
        },
      ],
    },
    {
      id: 12,
      name: 'VO2Max - Relative [ml/min/kg]',
      slug: 'vo2max',
      datapoint: 'data_point-2',
      value: 'vo2max__data_point-2',
      color: '#66a3ff',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [22.5, 46.25, 37.5, 72.5]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [22.5, 46.25, 37.5, 72.5]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [22.5, 46.25, 37.5, 72.5]
        },
        {
          sport_id_list: [68],
          data_set: [22.5, 46.25, 37.5, 72.5]
        },
        {
          sport_id_list: [86],
          data_set: [22.5, 46.25, 37.5, 72.5]
        },
        {
          sport_id_list: [81, 79],
          data_set: [22.5, 46.25, 37.5, 72.5]
        },
        {
          sport_id_list: [71],
          data_set: [22.5, 46.25, 37.5, 72.5]
        },
      ],
    },
    {
      id: 13,
      name: 'VLamax [mmol/l/s]',
      slug: 'vlamax',
      datapoint: 'data_point-1',
      value: 'vlamax__data_point-1',
      color: 'FireBrick',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [0,2, 0.6, 1, 0.4]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [0,2, 0.6, 1, 0.4]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [0,2, 0.6, 1, 0.4]
        },
        {
          sport_id_list: [68],
          data_set: [0,2, 0.6, 1, 0.4]
        },
        {
          sport_id_list: [86],
          data_set: [0,2, 0.6, 1, 0.4]
        },
        {
          sport_id_list: [81, 79],
          data_set: [0,2, 0.6, 1, 0.4]
        },
        {
          sport_id_list: [71],
          data_set: [0,2, 0.6, 1, 0.4]
        },
      ],
    },
    {
      id: 14,
      name: 'Anaerobic Threshold - MLSS [{0}]',
      slug: 'anaerobic_threshold',
      datapoint: 'data_point-1',
      value: 'anaerobic_threshold__data_point-1',
      color: '#6A5ACD',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [3.6, 7.933333333, 14.6, 9.933333333]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [1.358624125, 1.462093674, 1.55060953, 1.493885688]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [1.192640933, 3.594937693, 6.970331432, 4.634535046]
        },
        {
          sport_id_list: [68],
          data_set: [2.701920077, 4.082066239, 5.375636834, 4.529601714]
        },
        {
          sport_id_list: [86],
          data_set: [0.923076923, 2.58974359, 5.153846154, 3.358974359]
        },
        {
          sport_id_list: [81, 79],
          data_set: [1.745664504, 4.220196181, 7.738731618, 5.301477875]
        },
        {
          sport_id_list: [71],
          data_set: [1.935483871, 4.265232975, 7.849462366, 5.340501792]
        },
      ],
    },
    {
      id: 15,
      name: 'Anaerobic Threshold - % VO2max [%]',
      slug: 'anaerobic_threshold',
      datapoint: 'data_point-3',
      color: '#2F4F4F',
      value: 'anaerobic_threshold__data_point-3',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [55, 65, 90, 85]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [55, 65, 90, 85]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [55, 65, 90, 85]
        },
        {
          sport_id_list: [68],
          data_set: [55, 65, 90, 85]
        },
        {
          sport_id_list: [86],
          data_set: [55, 65, 90, 85]
        },
        {
          sport_id_list: [81, 79],
          data_set: [55, 65, 90, 85]
        },
        {
          sport_id_list: [71],
          data_set: [155, 65, 90, 85]
        },
      ],
    },
    {
      id: 16,
      name: 'Fat Max - MFO absolute [kcal/h]',
      slug: 'fat_max',
      datapoint: 'data_point-1',
      value: 'fat_max__data_point-1',
      color: '#228B22',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [200, 500, 700, 850]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [200, 500, 700, 850]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [200, 500, 700, 850]
        },
        {
          sport_id_list: [68],
          data_set: [200, 500, 700, 850]
        },
        {
          sport_id_list: [86],
          data_set: [200, 500, 700, 850]
        },
        {
          sport_id_list: [81, 79],
          data_set: [200, 500, 700, 850]
        },
        {
          sport_id_list: [71],
          data_set: [200, 500, 700, 850]
        },
      ],
    },
    {
      id: 17,
      name: 'Fat Max - MFO relative [kcal/h/kg]',
      slug: 'fat_max',
      datapoint: 'data_point-2',
      value: 'fat_max__data_point-2',
      color: '#66c266',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [2, 4, 6, 11]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [2, 4, 6, 11]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [2, 4, 6, 11]
        },
        {
          sport_id_list: [68],
          data_set: [2, 4, 6, 11]
        },
        {
          sport_id_list: [86],
          data_set: [2, 4, 6, 11]
        },
        {
          sport_id_list: [81, 79],
          data_set: [2, 4, 6, 11]
        },
        {
          sport_id_list: [71],
          data_set: [2, 4, 6, 11]
        },
      ],
    },
    {
      id: 18,
      name: 'Fat Max - FatMax [{0}]',
      slug: 'fat_max',
      datapoint: 'data_point-3',
      value: 'fat_max__data_point-3',
      color: '#006400',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [2.52, 5.553333333, 10.22, 6.953333333]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [0.951036887, 1.023465572, 1.085426671, 1.045719982]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [0.834848653, 2.516456385, 4.879232002, 3.244174532]
        },
        {
          sport_id_list: [68],
          data_set: [1.891344054, 2.857446367, 3.762945784	, 3.1707212]
        },
        {
          sport_id_list: [86],
          data_set: [0.646153846, 1.812820513, 3.607692308, 2.351282051]
        },
        {
          sport_id_list: [81, 79],
          data_set: [1.221965153, 2.954137326, 5.417112132, 3.711034512]
        },
        {
          sport_id_list: [71],
          data_set: [1.35483871, 2.985663082, 5.494623656, 3.738351254]
        },
      ],
    },
    {
      id: 19,
      name: 'Carb Max - Carbmax [{0}]',
      slug: 'carb_max',
      datapoint: 'data_point-1',
      value: 'carb_max__data_point-1',
      color: 'OrangeRed',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [2.652631579, 5.845614035, 10.75789474, 7.319298246]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [1.00109146, 1.077332181, 1.14255439, 1.100757876]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [0.878788056, 2.648901458, 5.136033687, 3.41492056]
        },
        {
          sport_id_list: [68],
          data_set: [1.990888478, 3.007838281, 3.960995562, 3.337601263]
        },
        {
          sport_id_list: [86],
          data_set: [0.680161943, 1.908232119, 3.79757085, 2.475033738]
        },
        {
          sport_id_list: [81, 79],
          data_set: [1.286279108, 3.109618238, 5.702223297, 3.906352118]
        },
        {
          sport_id_list: [71],
          data_set: [1.42614601, 3.142803245, 5.783814375, 3.935106584]
        },
      ],
    },
    {
      id: 20,
      name: 'Carb Max - Carbmax',
      slug: 'carb_max',
      datapoint: 'data_point-2',
      value: 'carb_max__data_point-2',
      color: '#a52a2a',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [1, 5, 2.5, 3]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [1, 5, 2.5, 3]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [1, 5, 2.5, 3]
        },
        {
          sport_id_list: [68],
          data_set: [1, 5, 2.5, 3]
        },
        {
          sport_id_list: [86],
          data_set: [1, 5, 2.5, 3]
        },
        {
          sport_id_list: [81, 79],
          data_set: [1, 5, 2.5, 3]
        },
        {
          sport_id_list: [71],
          data_set: [1, 5, 2.5, 3]
        },
      ],
    },
    {
      id: 21,
      name: 'Available Glycogen - Absolute [g]',
      slug: 'available_glycogen',
      datapoint: 'data_point-1',
      color: '#FFA500',
      value: 'available_glycogen__data_point-1',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [200, 480, 650, 370]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [200, 480, 650, 370]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [200, 480, 650, 370]
        },
        {
          sport_id_list: [68],
          data_set: [200, 480, 650, 370]
        },
        {
          sport_id_list: [86],
          data_set: [200, 480, 650, 370]
        },
        {
          sport_id_list: [81, 79],
          data_set: [200, 480, 650, 370]
        },
        {
          sport_id_list: [71],
          data_set: [200, 480, 650, 370]
        },
      ],
    },
    {
      id: 22,
      name: 'Available Glycogen - Relative [g/kg]',
      slug: 'available_glycogen',
      datapoint: 'data_point-2',
      value: 'available_glycogen__data_point-2',
      color: '#FFD580',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [2, 6, 8, 5]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [2, 6, 8, 5]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [2, 6, 8, 5]
        },
        {
          sport_id_list: [68],
          data_set: [2, 6, 8, 5]
        },
        {
          sport_id_list: [86],
          data_set: [2, 6, 8, 5]
        },
        {
          sport_id_list: [81, 79],
          data_set: [2, 6, 8, 5]
        },
        {
          sport_id_list: [71],
          data_set: [2, 6, 8, 5]
        },
      ],
    },
    {
      id: 23,
      name: 'VO2 kinetics Tau [s]',
      slug: 'vo2_tau',
      datapoint: 'data_point-1',
      value: 'vo2_tau__data_point-1',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [8, 15, 27, 18]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [8, 15, 27, 18]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [8, 15, 27, 18]
        },
        {
          sport_id_list: [68],
          data_set: [8, 15, 27, 18]
        },
        {
          sport_id_list: [86],
          data_set: [8, 15, 27, 18]
        },
        {
          sport_id_list: [81, 79],
          data_set: [8, 15, 27, 18]
        },
        {
          sport_id_list: [71],
          data_set: [8, 15, 27, 18]
        },
      ],
    },
    {
      id: 24,
      name: 'Average Power [{0}]',
      slug: 'avg_power',
      datapoint: 'data_point-1',
      value: 'avg_power__data_point-1',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [29.92387233, 2, 21.51847795	, 17.09910807]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [1.288466817, 1.134459618, 1.23972149, 1.206906351]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [11.54394802, 2, 8.733863447, 7.17547363]
        },
        {
          sport_id_list: [68],
          data_set: [7.756141547, 2, 6.622798733, 5.927605215]
        },
        {
          sport_id_list: [86],
          data_set: [11.04177086, 2, 8.050639731, 6.449199638]
        },
        {
          sport_id_list: [81, 79],
          data_set: [12.08456026, 2, 9.173450146, 7.561361219]
        },
        {
          sport_id_list: [71],
          data_set: [14.60397167, 2, 10.7075136, 8.62429039]
        },
      ],
    },
    {
      id: 25,
      name: 'Maximum Speed [{0}]',
      slug: 'max_power',
      datapoint: 'data_point-1',
      value: 'max_power__data_point-1',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [42.74838904, 14.33498048, 30.74068278, 4.42729724]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [1.840666881, 1.620656597, 1.7710307, 1.72415193]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [16.49135432, 6.43123533, 12.47694778, 10.25067661]
        },
        {
          sport_id_list: [68],
          data_set: [11.08020221, 6.522867221, 9.461141048, 8.468007449]
        },
        {
          sport_id_list: [86],
          data_set: [15.77395838, 5.466664163, 11.5009139, 9.213142341]
        },
        {
          sport_id_list: [81, 79],
          data_set: [17.26365752, 6.862519986, 13.10492878, 10.8019446]
        },
        {
          sport_id_list: [71],
          data_set: [20.86281667, 7.460421954, 15.296448, 12.32041484]
        },
      ],
    },
    {
      id: 26,
      name: 'Body Fat [%]',
      slug: 'body_fat',
      datapoint: 'data_point-1',
      value: 'body_fat__data_point-1',
      color: 'MediumVioletRed',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [4, 15, 40, 25]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [4, 15, 40, 25]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [4, 15, 40, 25]
        },
        {
          sport_id_list: [68],
          data_set: [4, 15, 40, 25]
        },
        {
          sport_id_list: [86],
          data_set: [4, 15, 40, 25]
        },
        {
          sport_id_list: [81, 79],
          data_set: [4, 15, 40, 25]
        },
        {
          sport_id_list: [71],
          data_set: [4, 15, 40, 25]
        },
      ],
    },
    {
      id: 27,
      name: 'MMSS [{0}]',
      slug: 'mmss',
      datapoint: 'data_point-1',
      value: 'mmss__data_point-1',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [3.816, 8.409333333, 15.476, 10.52933333]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [1.440141572, 1.549819295, 1.643646101, 1.58351883]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [1.264199389, 3.810633954, 7.388551318, 4.912607149]
        },
        {
          sport_id_list: [68],
          data_set: [2.864035282, 4.326990213, 5.698175044, 4.801377817]
        },
        {
          sport_id_list: [86],
          data_set: [0.978461538, 2.745128205, 5.463076923, 3.560512821]
        },
        {
          sport_id_list: [81, 79],
          data_set: [1.850404374, 4.473407952, 8.203055515, 5.619566547]
        },
        {
          sport_id_list: [71],
          data_set: [2.051612903, 4.521146953, 8.320430108, 5.6609319]
        },
      ],
    },
    {
      id: 29,
      name: 'Minimum Lactate Equivalent [mmol/l/min]',
      slug: 'min_lactate_eq',
      datapoint: 'data_point-1',
      value: 'min_lactate_eq__data_point-1',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [0.25, 0.65, 0.75, 1.15]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [0.25, 0.65, 0.75, 1.15]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [0.25, 0.65, 0.75, 1.15]
        },
        {
          sport_id_list: [68],
          data_set: [0.25, 0.65, 0.75, 1.15]
        },
        {
          sport_id_list: [86],
          data_set: [0.25, 0.65, 0.75, 1.15]
        },
        {
          sport_id_list: [81, 79],
          data_set: [0.25, 0.65, 0.75, 1.15]
        },
        {
          sport_id_list: [71],
          data_set: [0.25, 0.65, 0.75, 1.15]
        },
      ],
    },
    {
      id: 30,
      name: 'Max Aerobic Speed [{0}]',
      slug: 'max_aerobic',
      datapoint: 'data_point-1',
      value: 'max_aerobic__data_point-1',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [3.816, 8.409333333, 15.476, 10.52933333]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [1.440141572, 1.549819295, 1.643646101, 1.58351883]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [1.264199389, 3.810633954, 7.388551318, 4.912607149]
        },
        {
          sport_id_list: [68],
          data_set: [2.864035282, 4.326990213, 5.698175044, 4.801377817]
        },
        {
          sport_id_list: [86],
          data_set: [0.978461538, 2.745128205, 5.463076923, 3.560512821]
        },
        {
          sport_id_list: [81, 79],
          data_set: [1.850404374, 4.473407952, 8.203055515, 5.619566547]
        },
        {
          sport_id_list: [71],
          data_set: [2.051612903, 4.521146953, 8.320430108, 5.6609319]
        },
      ],
    },
    {
      id: 31,
      name: 'Anaerobic Speed Reserve [{0}]',
      slug: 'anaerobic_reserve',
      datapoint: 'data_point-1',
      value: 'anaerobic_reserve__data_point-1',
      data: [
        {
          sport_id_list: [69, 65, 54],
          data_set: [3.816, 8.409333333, 15.476, 10.52933333]
        },
        {
          sport_id_list: [58, 59, 60, 5],
          data_set: [1.440141572, 1.549819295, 1.643646101, 1.58351883]
        },
        {
          sport_id_list: [56, 53, 55],
          data_set: [1.264199389, 3.810633954, 7.388551318, 4.912607149]
        },
        {
          sport_id_list: [68],
          data_set: [2.864035282, 4.326990213, 5.698175044, 4.801377817]
        },
        {
          sport_id_list: [86],
          data_set: [0.978461538, 2.745128205, 5.463076923, 3.560512821]
        },
        {
          sport_id_list: [81, 79],
          data_set: [1.850404374, 4.473407952, 8.203055515, 5.619566547]
        },
        {
          sport_id_list: [71],
          data_set: [2.051612903, 4.521146953, 8.320430108, 5.6609319]
        },
      ],
    },
  ]
}
export const POWER_DROPDOWN_Y_AXIS_CONFIG = {
  optionList: [
    {
      id: 1,
      name: 'Recovery Index',
      slug: 'recovery_index',
      datapoint: 'data_point-0',
      value: 'recovery_index__data_point-0',
      color: '#48D1CC',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [10, 50, 95, 67]
        }
      ],
    },
    {
      id: 2,
      name: 'Accumulation Index',
      slug: 'accumulation_index',
      datapoint: 'data_point-0',
      color: '#00CED1',
      value: 'accumulation_index__data_point-0',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [95, 67, 10, 50]
        }
      ],
    },
    {
      id: 3,
      name: 'W` - Absolute [kJ]',
      slug: 'w_prime',
      datapoint: 'data_point-1',
      value: 'w_prime__data_point-1',
      color: '#4B0014',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [700, 1500, 2400, 1700]
        }
      ],
    },
    {
      id: 4,
      name: 'W` - Relative [kJ/kg]',
      slug: 'w_prime',
      datapoint: 'data_point-2',
      value: 'w_prime__data_point-2',
      color: '#8a5966',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [11, 21, 28, 23]
        }
      ],
    },
    {
      id: 5,
      name: 'Max Lactate [mmol/l]',
      slug: 'max_lactate',
      datapoint: 'data_point-1',
      value: 'max_lactate__data_point-1',
      color: '#FF2400',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [6, 11, 25, 16]
        }
      ],
    },
    {
      id: 6,
      name: 'Max Heart Rate - Maximum [bpm]',
      slug: 'max_hr',
      datapoint: 'data_point-1',
      value: 'max_hr__data_point-1',
      color: '#800000',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [140, 190, 220, 175]
        }
      ],
    },
    {
      id: 7,
      name: 'Max Heart Rate - PWC150 [Watt]',
      slug: 'max_hr',
      datapoint: 'data_point-2',
      value: 'max_hr__data_point-2',
      color: '#993333',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [110, 240, 440, 300]
        }
      ],
    },
    {
      id: 8,
      name: 'Economy',
      slug: 'economy',
      datapoint: 'data_point-1',
      color: 'black',
    },
    {
      id: 9,
      name: 'LT1 - Absolute [Watt]',
      slug: 'lt_1',
      datapoint: 'data_point-1',
      value: 'lt1__data_point-1',
      color: '#DB7093',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [80, 120, 350, 250]
        }
      ],
    },
    {
      id: 10,
      name: 'LT1 - Relative [Watt/kg]',
      datapoint: 'data_point-2',
      value: 'lt1__data_point-2',
      slug: 'lt_1',
      color: '#e8a2b9',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [1, 2, 5.5, 3]
        }
      ],
    },
    {
      id: 11,
      name: 'VO2Max - Absolute [ml/min]',
      slug: 'vo2max',
      datapoint: 'data_point-1',
      value: 'vo2max__data_point-1',
      color: 'blue',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [2000, 4000, 3000, 6500]
        }
      ],
    },
    {
      id: 12,
      name: 'VO2Max - Relative [ml/min/kg]',
      slug: 'vo2max',
      datapoint: 'data_point-2',
      value: 'vo2max__data_point-2',
      color: '#66a3ff',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [25, 65, 40, 85]
        }
      ],
    },
    {
      id: 13,
      name: 'VLamax [mmol/l/s]',
      slug: 'vlamax',
      datapoint: 'data_point-1',
      value: 'vlamax__data_point-1',
      color: 'FireBrick',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [0.2, 0.6, 1, 0.4]
        }
      ],
    },
    {
      id: 14,
      name: 'Anaerobic Threshold - Absolute [Watt]',
      slug: 'anaerobic_threshold',
      datapoint: 'data_point-1',
      value: 'anaerobic_threshold__data_point-1',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [120, 250, 450, 310]
        }
      ],
    },
    {
      id: 15,
      name: 'Anaerobic Threshold - Relative [Watt/kg]',
      slug: 'anaerobic_threshold',
      datapoint: 'data_point-2',
      value: 'anaerobic_threshold__data_point-2',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [1.5, 3.2, 6.7, 4]
        }
      ],
    },
    {
      id: 16,
      name: 'Anaerobic Threshold - % VO2max [%]',
      slug: 'anaerobic_threshold',
      datapoint: 'data_point-3',
      value: 'anaerobic_threshold__data_point-3',
      color: '#2F4F4F',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [55, 65, 90, 85]
        }
      ],
    },
    {
      id: 17,
      name: 'Fat Max - MFO absolute [kcal/h]',
      slug: 'fat_max',
      datapoint: 'data_point-1',
      value: 'fat_max__data_point-1',
      color: '#228B22',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [200, 500, 700, 850]
        }
      ],
    },
    {
      id: 18,
      name: 'Fat Max - MFO relative [kcal/h/kg]',
      slug: 'fat_max',
      datapoint: 'data_point-2',
      value: 'fat_max__data_point-2',
      color: '#66c266',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [2,	4,	6,	11]
        }
      ],
    },
    {
      id: 19,
      name: 'Fat Max - FatMax [Watt]',
      slug: 'fat_max',
      datapoint: 'data_point-3',
      value: 'fat_max__data_point-3',
      color: '#006400',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [80, 350, 180, 250]
        }
      ],
    },
    {
      id: 20,
      name: 'Carb Max - Absolute [Watt]',
      slug: 'carb_max',
      datapoint: 'data_point-1',
      value: 'carb_max__data_point-1',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [80,	350,	180,	250]
        }
      ],
    },
    {
      id: 21,
      name: 'Carb Max - Relative [Watt/kg]',
      slug: 'carb_max',
      datapoint: 'data_point-2',
      value: 'carb_max__data_point-2',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [1, 5, 2.5,	3]
        }
      ],
    },
    {
      id: 22,
      name: 'Available Glycogen - Absolute [g]',
      slug: 'available_glycogen',
      datapoint: 'data_point-1',
      value: 'available_glycogen__data_point-1',
      color: '#FFA500',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [200, 480, 650, 370]
        }
      ],
    },
    {
      id: 23,
      name: 'Available Glycogen - Relative [g/kg]',
      slug: 'available_glycogen',
      datapoint: 'data_point-2',
      color: '#FFD580',
      value: 'available_glycogen__data_point-2',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [2, 6, 8, 5]
        }
      ],
    },
    {
      id: 24,
      name: 'Tau [s]',
      slug: 'vo2_tau',
      datapoint: 'data_point-1',
      value: 'vo2_tau__data_point-1'
    },
    {
      id: 25,
      name: 'Average Power - Absolute [Watt]',
      slug: 'avg_power',
      datapoint: 'data_point-1',
      value: 'avg_power__data_point-1',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [1750, 500, 1200, 900]
        }
      ],
    },
    {
      id: 26,
      name: 'Average Power - Relative [Watt/kg]',
      slug: 'avg_power',
      datapoint: 'data_point-2',
      value: 'avg_power__data_point-2',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [20, 6, 11, 9]
        }
      ],
    },
    {
      id: 27,
      name: 'Maximum Power - Absolute [Watt]',
      slug: 'max_power',
      datapoint: 'data_point-1',
      value: 'max_power__data_point-1',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [2500, 700, 1700, 1300]
        }
      ],
    },
    {
      id: 28,
      name: 'Maximum Power - Relative [Watt/kg]',
      slug: 'max_power',
      datapoint: 'data_point-2',
      value: 'max_power__data_point-2',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [28, 8, 17, 13]
        }
      ],
    },
    {
      id: 29,
      name: 'MLSS - Absolute [Watt]',
      slug: 'MLSS',
      datapoint: 'data_point-1',
      value: 'MLSS__data_point-1',
      color: '#483D8B',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [120, 250, 450, 310]
        }
      ],
    },
    {
      id: 30,
      name: 'MLSS - Relative [Watt/kg]',
      slug: 'MLSS',
      datapoint: 'data_point-2',
      value: 'MLSS__data_point-2',
      color: '#483D8B',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [1,5, 3.2, 6.7, 4]
        }
      ],
    },
    {
      id: 31,
      name: 'MLSS - % VO2max [%]',
      slug: 'MLSS',
      datapoint: 'data_point-3',
      value: 'MLSS__data_point-3',
      color: '#483D8B',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [55, 65, 90, 85]
        }
      ],
    },
    {
      id: 32,
      name: 'Body Fat [%]',
      slug: 'body_fat',
      datapoint: 'data_point-1',
      value: 'body_fat__data_point-1',
      color: 'MediumVioletRed',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [4, 15, 40, 25]
        }
      ],
    },
    {
      id: 33,
      name: 'MMSS - Absolute [Watt]',
      slug: 'mmss',
      datapoint: 'data_point-1',
      value: 'mmss__data_point-1',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [130, 260, 460, 320]
        }
      ],
    },
    {
      id: 34,
      name: 'MMSS - Relative [Watt/kg]',
      slug: 'mmss',
      datapoint: 'data_point-2',
      value: 'mmss__data_point-2',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [1,5, 3.5, 7, 4]
        }
      ],
    },
    {
      id: 36,
      name: 'Minimum Lactate Equivalent [mmol/l/min]',
      slug: 'min_lactate_eq',
      datapoint: 'data_point-1',
      value: 'min_lactate_eq__data_point-1',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [0.25, 0.65, 0.75, 1.15]
        }
      ],
    },
    {
      id: 37,
      name: 'Max Aerobic Power - Absolute [Watt]',
      slug: 'max_aerobic',
      datapoint: 'data_point-1',
      value: 'max_aerobic__data_point-1',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [134, 255, 477, 310]
        }
      ],
    },
    {
      id: 38,
      name: 'Max Aerobic Power - Relative [Watt/kg]',
      slug: 'max_aerobic',
      datapoint: 'data_point-2',
      value: 'max_aerobic__data_point-2',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [1.4, 3.8, 6.5, 4.5]
        }
      ],
    },
    {
      id: 37,
      name: 'Anaerobic Power Reserve - Absolute [Watt]',
      slug: 'anaerobic_reserve',
      datapoint: 'data_point-1',
      value: 'anaerobic_reserve__data_point-1',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [145, 265, 487, 300]
        }
      ],
    },
    {
      id: 38,
      name: 'Anaerobic Power Reserve - Relative [Watt/kg]',
      slug: 'anaerobic_reserve',
      datapoint: 'data_point-2',
      value: 'anaerobic_reserve__data_point-2',
      data: [
        {
          sport_id_list: [50, 57, 61, 62, 78, 83],
          data_set: [1.6, 2.8, 5.5, 2.5]
        }
      ],
    },
  ]
};
